import { Flex, Space } from "antd";
import AnnoucementTable from "./AnnouncementTable";
import AnnouncementForm from "../../forms/AnnoucementForm";

export default function Announcement() {
  return (
    <Space size="large" direction="vertical" className="full-width">
      <Flex gap="large" wrap="wrap">
        <AnnouncementForm />
      </Flex>
      <AnnoucementTable />
    </Space>
  );
}
